import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, EntityModel, LocationModel, MeterModel, ObjectReferenceModel, SchemaModel, ResponseListModel, ResponseDeleteModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { IImportService } from './api.app.service'

export interface IMetersService extends IImportService {
    getMeters(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getMeter(id: number, state?: any): ng.IPromise<MeterModel>
    getMeterToEdit(id: number, state?: any): ng.IPromise<EntityModel>
    saveMeter(req): ng.IPromise<MeterModel>
    deleteMeter(id): ng.IPromise<ResponseDeleteModel>
    changeCurrentDevice(model: ObjectReferenceModel): ng.IPromise<MeterModel>
    getSchema(id, state?: any): ng.IPromise<SchemaModel>
    getSchemas(id, state?: any): ng.IPromise<ResponseListModel<SchemaModel>>
    getAlarmGroups(id:number, state?: any): ng.IPromise<GridModel>
    getAlarmDefs(id:number, state?: any): ng.IPromise<GridModel>
}

export class MetersService implements IMetersService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getMeters(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.meters.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)            
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getAlarmDefs(id: number, state: any = {}) {
        var getAlarmDefs: ng.resource.IResourceMethod<ng.resource.IResource<GridModel>> = this.apiResource.meters['getAlarmDefs']
        state.request = getAlarmDefs({id: id})
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            if (result.values) { //replacing field 'visible' to field 'isVisible' in alarm definition. property visible is used in dataSource and if false DE dont show such record
                result.values.forEach(t => {
                    if ('visible' in t) {
                        t.isVisible = t.visible
                        delete t.visible
                    }
                })
            }
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getAlarmGroups(id: number, state: any = {}) {
        var getAlarmGroups: ng.resource.IResourceMethod<ng.resource.IResource<GridModel>> = this.apiResource.meters['getAlarmGroups']
        state.request = getAlarmGroups({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)            
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getMeter(id: number, state: any = {}) {
        var get = this.apiResource.meters.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            if (result.alarmDefs && result.alarmDefs.values) { //replacing field 'visible' to field 'isVisible' in alarm definition. property visible is used in dataSource and if false DE dont show such record
                result.alarmDefs.values.forEach(t => {
                    if ('visible' in t) {
                        t.isVisible = t.visible
                        delete t.visible
                    }
                })
            }
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getMeterToEdit(id: number, state: any = {}) {
        var getMeterToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.meters['getMeterToEdit']
        state.request = getMeterToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveMeter(req): ng.IPromise<MeterModel> {
        return this.apiResource.meters.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            if (result.alarmDefs && result.alarmDefs.values) { //replacing field 'visible' to field 'isVisible' in alarm definition. property visible is used in dataSource and if false DE dont show such record
                result.alarmDefs.values.forEach(t => {
                    if ('visible' in t) {
                        t.isVisible = t.visible
                        delete t.visible
                    }
                })
            }
            return (<any>result).toJSON()
        }).catch<any>(rej => {
            console.log(rej)
            return CommonHelper.handleRejection(this.apiResource, rej.status)
        })
    }

    deleteMeter(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.meters.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    changeCurrentDevice(model: ObjectReferenceModel) {
        return this.apiResource.meters['changeCurrentDevice'](model).$promise.then(result => {
            result = CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getSchema(id, state: any = {}) {
        var get = this.apiResource.locations['getSchema']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getSchemas(id, state: any = {}) {
        var get = this.apiResource.meters['getSchemas']
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    IsImportCompleted(model: GridModel) {
        return this.apiResource.meters['importIsCompleted'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportSummary(model: GridModel) {
        return this.apiResource.meters['importResume'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    initImport(model: GridModel) {
        return this.apiResource.meters['importInit'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    validateImport(guid: string) {
        return this.apiResource.meters['importValidate']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportData(guid: string) {
        return this.apiResource.meters['importGetData']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    startImport(guid: string) {
        return this.apiResource.meters['importStart']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    stopImport(guid: string) {
        return this.apiResource.meters['importStop']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importProgress(guid: string) {
        return this.apiResource.meters['importProgress']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importSummary(guid: string) {
        return this.apiResource.meters['importSummary']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
